import React from "react"
import { useVersionCheck } from "./useVersionCheck"

export const VersionBanner: React.FC = () => {
  const outdated = useVersionCheck(30_000)
  if (!outdated) return null

  return (
    <div
      style={{
        position: "fixed", bottom: 16, left: 16, padding: "10px 12px",
        background: "#1f2937", color: "#fff", borderRadius: 8, zIndex: 9999,
        boxShadow: "0 6px 20px rgba(0,0,0,0.25)",
      }}
    >
      Nouvelle version disponible.
      <button
        style={{ marginLeft: 8, padding: "6px 10px", borderRadius: 6, border: 0, cursor: "pointer" }}
        onClick={() => location.reload()}
      >
        Mettre à jour
      </button>
    </div>
  )
}